import React, { CSSProperties } from 'react';
import Icon from '../../../../../muiComponents/Icon';
import Tooltip from '../../../../../muiComponents/Tooltip';

type StarRatingProps = {
    rating: number;
    max?: number;
    title: string;
};

const StarRating = ({ rating, max = 6, title }: StarRatingProps) => {
    const stars = [];
    const style: CSSProperties = {
        color: '#ff8c1b', //$accentColorOrange400,
    };

    for (let i = 1; i <= max; i++) {
        if (i <= rating) {
            stars.push(<Icon key={i} iconName='Star' style={style} />);
        } else if (i - rating <= 0.5) {
            stars.push(<Icon key={i} iconName='StarHalf' style={style} />);
        } else {
            stars.push(<Icon key={i} iconName='StarOutline' style={style} />);
        }
    }

    return (
        <Tooltip title={title}>
            <div className='flex width-content'>{stars}</div>
        </Tooltip>
    );
};

export default StarRating;
